<template>
    <!-- Use the AppTitle component -->
    <AppTitle>
        <template #title>ค่าแรงดันแก๊ส</template>
        <template #subtitle> Wanon Niwat Hospital [5S SYSTEM WNH] </template>
        <template #breadcrumb>หน้าหลัก</template>
    </AppTitle>

    <div class="row">
        <div class="col-md-12">
            <div class="tile">
                <Overlay :showOverlay="isLoading" />

                <!-- <div class="tile-title-w-btn">
                    <h3 class="title">ค่าแรงดันแก๊ส ทั้งหมด</h3>
                    <p>
                        <a class="btn btn-primary icon-btn" href="#" @click="openAddModal">
                            <i class="bi bi-plus-square me-2"></i> Add Item
                        </a>
                    </p>
                </div> -->

                <div class="tile-title-w-btn d-flex justify-content-between align-items-center">
                    <h3 class="title">ค่าแรงดันแก๊ส ทั้งหมด</h3>

                    <div class="d-flex align-items-center gap-2">
                        <select v-model="filterKey" class="form-select" style="width: auto;">
                            <option value="code">Code</option>
                            <option value="name">Name</option>
                            <option value="location">Location</option>
                            <option value="group.name">Department</option>
                        </select>
                        <!-- Conditional filter field -->
                        <input v-if="filterKey !== 'group.name'" type="text" v-model="filterText"
                            placeholder="Search..." class="form-control" style="width: 200px;" />

                        <select v-else class="form-select" v-model="selectedGroupId" style="width: 200px;">
                            <option value="">All Departments</option>
                            <option v-for="group in groups" :key="group.id" :value="group.id">
                                {{ group.name }}
                            </option>
                        </select>
                        <p>
                            <a class="btn btn-primary icon-btn" href="#" @click="openAddModal">
                                <i class="bi bi-plus-square me-2"></i> Add Item
                            </a>
                        </p>
                    </div>
                </div>

                <div class="tile-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Code</th>
                                    <th>Name</th>
                                    <th>Location</th>
                                    <th>Department</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(value, index) in filteredItems" :key="value.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ value.code }}</td>
                                    <td>{{ value.name }}</td>
                                    <td>{{ value.location }}</td>
                                    <td>{{ value.group?.name }}</td>
                                    <td>
                                        <div class="btn-group btn-group-sm" role="group">
                                            <button type="button" class="btn btn-warning" @click="openEditModal(value)">
                                                <i class="bi bi-pencil"></i> Edit
                                            </button>
                                            <button type="button" class="btn btn-danger"
                                                @click="handleDelete(value.id)">
                                                <i class="bi bi-trash"></i> Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Modal -->
                    <div class="modal fade" id="myModal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="modalLabel">
                                        {{ modalMode === 'edit' ? 'Edit Item' : 'Add Item' }}
                                    </h5>
                                    <button type="button" class="btn-close" aria-label="Close"
                                        @click="hideModal"></button>
                                </div>
                                <form @submit.prevent="handleSubmit">
                                    <div class="modal-body">
                                        <!-- Download QR code button -->
                                        <div v-if="modalMode != 'add'" class="text-center mt-3">
                                            <button type="button" @click="downloadQRCode"
                                                class="btn btn-success">Download
                                                QR
                                                Code</button>
                                        </div>

                                        <div v-if="editingItem.code" ref="qrCodeContainer" class="text-center p-4">
                                            <div class="text-center mb-3">
                                                <qrcode-vue :value="`${url}/${editingItem.code}`"
                                                    size="128"></qrcode-vue>
                                            </div>
                                            <p class="mb-0">
                                                {{ editingItem.name }} [{{ editingItem.code }}] {{
                                                    editingItem.location }}
                                            </p>
                                            <p class="mb-0">
                                                {{ editingItem.group?.name }}
                                            </p>
                                        </div>

                                        <div class="mb-3">
                                            <label for="name" class="form-label">Name</label>
                                            <input type="text" id="name" class="form-control" v-model="editingItem.name"
                                                required />
                                        </div>
                                        <div class="mb-3">
                                            <label for="location" class="form-label">Location</label>
                                            <input type="text" id="location" class="form-control"
                                                v-model="editingItem.location" />
                                        </div>
                                        <div class="mb-3">
                                            <label for="group" class="form-label">Department</label>
                                            <select id="group" class="form-select" v-model="editingItem.group_id"
                                                required>
                                                <option value="" disabled>- Select -</option>
                                                <option v-for="dept in groups" :key="dept.id" :value="dept.id">
                                                    {{ dept.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            @click="hideModal">Close</button>
                                        <button type="submit" class="btn btn-primary" :disabled="isSubmitting">
                                            <span v-if="isSubmitting">
                                                <span class="spinner-border spinner-border-sm me-1" role="status"
                                                    aria-hidden="true"></span>
                                                Saving...
                                            </span>
                                            <span v-else>Save changes</span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axiosInstance from '@/utils/axiosInstance';
import { showConfirm, showDeleteAlert, showErrorAlert, showSuccessAlert, showUpdateAlert } from '@/utils/sweetalert2-utils';
import Overlay from '@/components/Overlay.vue';
import { Modal } from 'bootstrap';
import QrcodeVue from 'qrcode.vue';
import html2canvas from 'html2canvas';
import AppTitle from '@/layouts/AppTitle.vue';

const gasValues = ref([]);
const modalMode = ref('add');
const editingItem = ref({ id: null, code: '', name: '', location: '', group_id: '' });
const groups = ref([]);
const url = ref(`${process.env.VUE_APP_URL_BASE}/view-gas-pressure-value`);
const qrCodeContainer = ref(null);
const isLoading = ref(false);

const filterKey = ref('code');
const filterText = ref('');

import { computed } from 'vue';
const selectedGroupId = ref('');

const filteredItems = computed(() => {
    return gasValues.value.filter(item => {
        if (filterKey.value === 'group.name') {
            return selectedGroupId.value
                ? item.group_id === selectedGroupId.value
                : true;
        } else {
            const value = item[filterKey.value] || '';
            return value.toLowerCase().includes(filterText.value.toLowerCase());
        }
    });
});

const fetchData = async () => {
    isLoading.value = true;
    try {
        const [dataRes, groupsRes] = await Promise.all([
            axiosInstance.get('/gas_pressure_value'),
            axiosInstance.get('/group'),
        ]);

        gasValues.value = dataRes.data;
        groups.value = groupsRes.data;
    } catch (error) {
        showErrorAlert('ไม่สามารถโหลดข้อมูลได้');
    } finally {
        isLoading.value = false;
    }
};

const openAddModal = () => {
    modalMode.value = 'add';
    editingItem.value = { id: null, code: '', name: 'ตู้ค่าแรงดันแก๊ส', location: '', group_id: '' };
    showModal();
};

const openEditModal = (value) => {
    modalMode.value = 'edit';
    editingItem.value = { ...value };
    showModal();
};

const isSubmitting = ref(false);

const handleSubmit = async () => {
    isSubmitting.value = true;

    try {
        if (modalMode.value === 'add') {
            await axiosInstance.post('/gas_pressure_value', editingItem.value);
            showSuccessAlert();
        } else {
            await axiosInstance.put(`/gas_pressure_value/${editingItem.value.id}`, editingItem.value);
            showUpdateAlert();
        }
        hideModal();
        fetchData();
    } catch (error) {
        showErrorAlert('เกิดข้อผิดพลาดในการบันทึกรายการ');

    } finally {
        isSubmitting.value = false;
    }
};

const handleDelete = async (id) => {
    const result = await showConfirm();
    if (result.isConfirmed) {
        try {
            await axiosInstance.delete(`/gas_pressure_value/${id}`);
            gasValues.value = gasValues.value.filter(value => value.id !== id);
            showDeleteAlert();
        } catch (error) {
            showErrorAlert('เกิดข้อผิดพลาดในการลบรายการ');
        }
    }
};

const showModal = () => {
    const modal = new Modal(document.getElementById('myModal'));
    modal.show();
};

const hideModal = () => {
    const modalElement = document.getElementById('myModal');
    const modal = Modal.getInstance(modalElement);
    modal.hide();
};

const downloadQRCode = () => {
    const qrCodeElement = qrCodeContainer.value;
    if (qrCodeElement) {
        html2canvas(qrCodeElement).then((canvas) => {
            const imageUrl = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = imageUrl;
            link.download = `${editingItem.value.code}_qr_code.png`;
            link.click();
        });
    }
};

onMounted(() => {
    fetchData();
});
</script>
